import * as $ from "jquery";

const ERRORNOSTUDENT = "Please type your name in the field to sign.";
const ERRORNOSTUDENTSCROLL =
    "Please review the entire Enrollment Agreement and type your name in the field to sign.";
const ERRORNOSCROLL =
    "Please review the entire Enrollment Agreement before you submit.";

export class EnrollAgreement {
    matchName: string;
    checkScrolled: boolean;
    errorMessage: string;
    $submitbutton: JQuery;
    $errormessage: JQuery;
    $studentname: JQuery;
    $eatext: JQuery;

    constructor(matchName: string) {
        const self = this;
        self.matchName = matchName;
        self.errorMessage = ERRORNOSTUDENTSCROLL;
        self.checkScrolled = false;
        self.$submitbutton = $("#submitbutton");
        self.$errormessage = $("#eanotread");
        self.$studentname = $("#studentname");
        self.$eatext = $("#ea-text");

        self.$studentname.on("keyup", function () {
            self.updateButton();
        });

        window.setInterval(() => self.updateButton(), 500);

        self.$submitbutton.on("click", function (e) {
            if ($(this).hasClass("disabled")) {
                e.preventDefault();
                self.$errormessage.text(self.errorMessage).show();
                $(document.body).animate({
                    "scrollTop": $("#ea-header").offset()!.top,
                }, 500);
            }
        });
    }

    updateButton() {
        const studentName = (<string> this.$studentname.val()).toLowerCase()
            .replace(/ +/g, " ").trim();
        const isStudent = studentName === this.matchName.toLowerCase();
        const isScrolled =
            (this.$eatext[0].scrollHeight - this.$eatext.scrollTop()!) <=
                this.$eatext.outerHeight()!;
        this.checkScrolled = isScrolled || this.checkScrolled;

        if (isStudent && this.checkScrolled) {
            this.$submitbutton.removeClass("disabled");
            this.$errormessage.hide();
        } else {
            if (!isStudent) {
                if (!this.checkScrolled) {
                    this.errorMessage = ERRORNOSTUDENTSCROLL;
                } else {
                    this.errorMessage = ERRORNOSTUDENT;
                }
            } else {
                this.errorMessage = ERRORNOSCROLL;
            }
            this.$submitbutton.addClass("disabled");
        }
    }
}
